/**
 * Low-level escape hatch for constructing flow nodes and guards without the
 * typed builder API. Use these when working with operation kinds not covered
 * by the generated methods, or when you need full control over the JSON shape.
 *
 * For most use cases, prefer the generated operation methods on {@link FlowBuilder}
 * (e.g. `builder.lifi.swap(...)`) and the typed guard/materialiser helpers.
 */
export { rawGuard as guard, ref } from './authoring/raw.js';
export { materialiser } from './run/inputs.js';
